export default __webpack_public_path__ + "static/incomplet-a3db34421a11c2c25b5cbff9cccca364.jpg";